import {
  AUTHORING_QUESTION_TYPES,
  type AuthoringQuestionType,
} from "@/lib/library-authoring"

import { DIFFICULTY_TAG_LABEL, normalizeDifficultyTag } from "./suggest-tags"
import type { QuestionQualityAlternate, QuestionQualityCheck } from "./types"

export function isSettingSuggestionCheck(
  check: Pick<QuestionQualityCheck, "field" | "settingsTarget">,
): boolean {
  return check.field === "settings" && Boolean(check.settingsTarget)
}

export function settingApplyLabel(alternate: QuestionQualityAlternate): string {
  const patch = alternate.patch
  if (patch?.type) {
    const format =
      AUTHORING_QUESTION_TYPES.find((row) => row.value === patch.type)
        ?.shortLabel ?? patch.type
    return `Use ${format}`
  }
  if (patch?.bloom) return `Use ${patch.bloom}`
  if (patch?.difficulty) {
    const tag = normalizeDifficultyTag(patch.difficulty)
    if (tag) return `Use ${DIFFICULTY_TAG_LABEL[tag]}`
  }
  return alternate.actionLabel
}
